<template>
  <q-page padding>
    <h3 class="q-mb-sm">Synth Online</h3>
    <p class="text-subtitle2 q-mb-xl">
      Please lower sound on your device beforehand<br><br>
      Use controls below, play a note and add effects.<br>
      Start with play button, stop with stop button (duh).
    </p>
    
    <q-btn round color="green-6" icon="play_arrow" class="q-mr-lg" @click="sineWave.play()" />
    <q-btn round color="green-6" icon="play_circle" class="q-mr-lg" @click="music.play()" />

    <q-btn round color="grey" icon="stop" @click="sineWave.stop()" /><br><br>

    <q-badge color="black">
      Frequency: {{ sineWave.frequency }}
    </q-badge>
    <q-slider v-model="sineWave.frequency" color="red-5" :step="25" :min="100" :max="400"/>

    <q-badge color="black">
      Volume: {{ sineWave.volume }}
    </q-badge>
    <q-slider v-model="sineWave.volume" color="red-5" :step="0.1" :min="0" :max="1"/>
   
    <h6 class="q-mb-none q-mt-lg">Flanger speed, depth</h6>    
    <q-toggle
        v-model="quadrafuzzOn"
        color="red-5"
        @update:model-value="toggleQuadra"
      />
    
    <q-knob
      :min="0.1"
      :max="1"
      v-model="flanger.speed"
      show-value
      size="70px"
      :thickness="0.22"
      :step=0.05
      color="red-5"
      track-color="grey-3"
      class="q-ma-md"
    />
    <q-knob
      :min="0.1"
      :max="1"
      v-model="flanger.depth"
      label="time"
      show-value
      size="70px"
      :thickness="0.22"
      :step=0.05
      color="red-5"
      track-color="grey-3"
      class="q-ma-md"
    />

    <h6 class="q-mb-none q-mt-lg">Tremolo depth</h6>    
    <q-toggle
        v-model="distortionOn"
        @update:model-value="toggleDist"
        color="red-5"
      />
    <q-knob
      :min="0.1"
      :max="1"
      v-model="tremolo.depth"
      show-value
      size="70px"
      :thickness="0.22"
      :step=0.05
      color="red-5"
      track-color="grey-3"
      class="q-ma-md"
    />


  </q-page>
</template>

<style></style>

<script>
import Pizzicato from 'pizzicato'
import bg from '../assets/bg.mp3'

export default {
  name: 'SynthOnline',
  // *----------------------- P r o p s ----------------------------------------------------------
  props: {},
  // *----------------------- D a t a -----------------------------------------------------------
  data() {
    return {
      sineWave: new Pizzicato.Sound({
        source: 'wave',
        options: {
            frequency: 220,
            volume: 0.5
        },
      }),
      music: new Pizzicato.Sound({
        source: 'file',
        options: { path: bg, volume: 0.5 }
      }),
      quadrafuzz: new Pizzicato.Effects.Quadrafuzz({
        lowGain: 0.6,
        midLowGain: 0.8,
        midHighGain: 0.5,
        highGain: 0.6,
        mix: 0.4
      }),
      pingPongDelay: new Pizzicato.Effects.PingPongDelay({
          feedback: 0.6,
          time: 0.4,
          mix: 0.5
      }),
      quadrafuzzOn: false,
      distortion: new Pizzicato.Effects.Distortion({
        gain: 0.4
      }),
      flanger: new Pizzicato.Effects.Flanger({
        time: 0.45,
        speed: 0.2,
        depth: 0.1,
        feedback: 0.1,
        mix: 0.5
      }),
      tremolo: new Pizzicato.Effects.Tremolo({
          speed: 0.5,
          depth: 0.8,
          mix: 0.8
      }),
      distortionOn: false,
    }
  },
  // *----------------------- C o m p u t e d ---------------------------------------------------
  computed: {},
  // *----------------------- L i f e   c i r c l e ---------------------------------------------
  created() {
    this.show()
  },
  // *----------------------- M e t h o d s -----------------------------------------------------
  methods: {
    show () {
      this.$q.dark.set(true)
    },
    toggleQuadra(value) {
      value ? this.sineWave.addEffect(this.flanger) : this.sineWave.removeEffect(this.flanger)
    },
    toggleDist(value) {
      value ? this.sineWave.addEffect(this.tremolo) : this.sineWave.removeEffect(this.tremolo)
    }
  },
  // *----------------------- W a t c h ---------------------------------------------------------
  watch: {}
}
</script>
